/**
 * @desc 物流渠道货物规格限制更新
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.LogisticsChannelLimitUpdateDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannel/channelLimit/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
